<script>
export default {
  name: "LoadingStep",

  components: {},
  data() {
    return {
      progress: 0,
      timer: null,
      messageIndex: 0,
      messages: [
        "Analyzing the submission...",
        "Applying the rubric...",
        "Generating detailed feedback and analysis...",
        "Generating grammar report...",
        "Calculating the grade based on the rubric...",
        "Preparing your results...",
      ],
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.progress++;
      if (this.progress % 14 === 0) {
        if (this.messageIndex < this.messages.length - 1) {
          this.messageIndex++;
        }
      }
    }, 400);
  },
  beforeMount() {
    clearInterval(this.timer);
  },
};
</script>

<template>
  <div class="d-flex flex-column align-items-center progress-wrapper">
    <h2>✨ We’re grading your essay</h2>
    <b-progress class="progressbar" :value="progress" :max="100" />
    <div class="progress-note">{{ messages[messageIndex] }}</div>
    <div class="progress-note description mt-3">
      (Grading in progress. This usually takes about 30 seconds.)
    </div>
  </div>
</template>

<style scoped lang="scss">
.progress-wrapper {
  width: 459px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  h2 {
    font-family: var(--typography-font-family-text-primary);
    font-weight: var(--typography-font-weight-fw-600);
    font-size: var(--typography-font-size-fs-700);
    line-height: 120%;
    letter-spacing: 0;
    vertical-align: bottom;
    color: #1c0f30;
  }
}
.progressbar {
  width: 75%;
  border-radius: 16px;
  height: 16px;
  margin: 16px 35px;
  ::v-deep {
    div[role="progressbar"] {
      background: linear-gradient(90deg, #be95ff 0%, #8a3ffc 100%);
    }
  }
}

.progress-note {
  font-family: var(--typography-font-family-text-primary);
  font-weight: var(--typography-font-weight-fw-400);
  font-size: var(--typography-font-size-fs-300);
  line-height: 140%;
  letter-spacing: 0;
  color: #1c0f30;
  text-align: center;
}
</style>
